'use client'
import React, { ReactElement, useState } from 'react'
import Market from '@/app/crazy/market'
import { BottomNavigation } from 'reactjs-bottom-navigation'
import '@/css/botton-nav.css'
import Head from 'next/head'
import NotYetOtc from './notyetotc'
import NotYetContests from '@/app/crazy/notyetcontests'
import NotYetErc414 from '@/app/crazy/notyeterc414'
import NotYetAiDao from '@/app/crazy/notyetaidao'
import NotYetCcip from '@/app/crazy/notyetccip'
import ContextProvider from '@/components/Context'
import ContextConsoleProvider from '@/components/ContextConsole'
import { ThirdwebProvider } from 'thirdweb/react'

import { Web3OnboardProvider } from '@web3-onboard/react'
import { getWeb3Onboard } from '@/utils/web3Onboard'

const Page = (): ReactElement => {
    const [navIndex, setNavIndex] = useState(0)
    const web3Onboard = getWeb3Onboard()

    const bottomNavItems = [
        {
            icon: <strong>NFT</strong>,
        },
        {
            icon: <strong>OTC</strong>,
        },
        {
            icon: <strong>Contests</strong>,
        },
        {
            icon: <strong>ERC-414</strong>,
        },
        {
            icon: <strong>AI DAO</strong>,
        },
        {
            icon: <strong>Cross-chain</strong>,
        },
    ]

    return (
        <ContextConsoleProvider>
            <Web3OnboardProvider web3Onboard={web3Onboard}>
                <ThirdwebProvider>
                    <ContextProvider>
                        <Head>
                            <meta name="viewport" content="width=400, initial-scale=1.0" />
                            <title>CRAZY DeFi NFT Marketplace</title>
                        </Head>
                        <div>
                            {navIndex === 0 ? <Market /> : <div />}
                            {navIndex === 1 ? <NotYetOtc /> : <div />}
                            {navIndex === 2 ? <NotYetContests /> : <div />}
                            {navIndex === 3 ? <NotYetErc414 /> : <div />}
                            {navIndex === 4 ? <NotYetAiDao /> : <div />}
                            {navIndex === 5 ? <NotYetCcip /> : <div />}
                            <BottomNavigation
                                items={bottomNavItems}
                                selected={0}
                                onItemClick={(item) => setNavIndex(item.id)}
                                activeBgColor="black"
                                activeTextColor="white"
                            />
                        </div>
                    </ContextProvider>
                </ThirdwebProvider>
            </Web3OnboardProvider>
        </ContextConsoleProvider>
    )
}

export default Page
